import React from "react";
import Login from "../components/loginPage/Login"

const Sign_in = () => {
    return (
        <div className="Sign_in">
            <Login />
        </div>
    );
};

export default Sign_in;